import { Box, BoxProps, IconButton, IconButtonProps, Typography, TypographyProps } from "@mui/material"
import { icons } from "../../utils/icons"
import { useStyles } from "./styles"

const ArrowBack = ({ label, arrowProps, boxProps, titleProps }: {
    label: string
    arrowProps: IconButtonProps
    boxProps?: BoxProps
    titleProps?:TypographyProps
}) => {
    const styles = useStyles()
    return (
        <Box {...boxProps} sx={{...styles.arrowHeaderDrawerContainer, ...boxProps?.sx || {}}}>
            <IconButton
                {...arrowProps}
                sx={{ ...styles.closeSettings, ...arrowProps.sx ?? {} }}
            >
                {icons('arrow-left-fill')}
            </IconButton>

            <Typography className="quest-name-header" {...titleProps}>{label}</Typography>
        </Box>
    )
}

export { ArrowBack }
